import React from 'react'
import { Card } from './Card'

interface EmptyStateProps {
  icon?: string
  title: string
  description?: React.ReactNode
  action?: React.ReactNode
  style?: React.CSSProperties
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon = '💬', title, description, action, style }) => (
  <Card style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)', ...style }}>
    <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{icon}</div>
    <div style={{ fontWeight: 600, marginBottom: '0.25rem', color: 'var(--text-primary)' }}>{title}</div>
    {description && <div style={{ fontSize: '0.875rem', marginBottom: action ? '1rem' : 0 }}>{description}</div>}
    {action}
  </Card>
)
